module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_purete-d5d303bc42e1ed4e63f1be7cb76b7683.jpg";